import * as React from 'react';
import { memo } from 'react';
import MediaQuery from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../utils';
import Toolbar from '../../Toolbar';
import { FooterMobile } from '@shared/ui';
const ServicesToolbar = memo(({ toolbarProps, footerMobileProps, children }) => {
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
            React.createElement(Toolbar, Object.assign({}, toolbarProps))),
        footerMobileProps && (React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement(FooterMobile, Object.assign({}, footerMobileProps))))));
});
export default ServicesToolbar;
